import $ from 'jquery';
import { breakpoints } from './variables';

const mobileStackBreakpoint = breakpoints.sm;

class MobileStackMenuTrigger {
	constructor($el) {
		this.$el = $el;
		this.$menuItem = this.$el.parent('.menu-item');
		this.$subMenu = this.$el.next('.sub-menu');

		if (this.$menuItem && this.$subMenu) {
			this.handleClick = this.handleClick.bind(this);
			this.$el.on('click', this.handleClick);

			this.handleResize = this.handleResize.bind(this);
			window.addEventListener('resize', this.handleResize);
		}
	}

	handleClick() {
		const speed = 300;
		const delay = this.$menuItem.hasClass('open') ? speed : 0;
		this.$subMenu.slideToggle(speed);
		setTimeout(() => {
			this.$menuItem.toggleClass('open');
		}, delay);
	}

	handleResize() {
		window.requestAnimationFrame(() => {
			if (mobileStackBreakpoint.aboveMin()) {
				this.$menuItem.removeClass('open');
				this.$subMenu.css('display', '');
			}
		});
	}
}

const mobileStackMenu = {
	init() {
		const $triggers = $('.menu--mobile-stack .menu-item__trigger');
		if ($triggers.length > 0) {
			$triggers.map((i, trigger) => new MobileStackMenuTrigger($(trigger)));
		}
	},
};

mobileStackMenu.init();
